import GATSBY_COMPILED_MDX from "/opt/build/repo/content/docs/03-cue-notation/index.mdx";
import React from "react";
import styled from "styled-components";
import {MDXProvider} from "@mdx-js/react";
import {AbletonCue} from "../elements/ableton-cue";
import {Header} from "../elements/header";
import {Footer} from "../elements/footer";
import {Button} from "../elements/button";
import {Video} from "../elements/video";
import {YouTube} from "../elements/youtube-embed";
import {VersionHeader} from "../elements/version-header";
import "../css/style.css";
import socialCard from "../images/social-card.jpg";
const socialImage = "https://ableset.app" + socialCard;
const shortcodes = {
  Button,
  YouTube,
  AC: AbletonCue,
  VersionHeader,
  Video
};
const Content = styled.div.withConfig({
  displayName: "content__Content",
  componentId: "sc-1qu0wep-0"
})(["line-height:1.7;padding:1rem;p,.yt-embed{margin-bottom:1rem;}a{text-decoration:underline;}a > p{margin:0;}.no-underline{text-decoration:none;}ul{list-style:disc;padding-left:1.5rem;}code:before,code:after{display:none;}h2:not(.version){font-size:2rem;margin-top:100px;text-align:center;&::after{content:\"\";display:block;height:0px;width:80px;margin:auto;margin-top:16px;margin-bottom:20px;border-bottom:2px solid #bbb;}}.anchor.before{fill:white;height:100%;display:flex;align-items:center;padding-right:0.5rem;}.gatsby-resp-image-wrapper,video,pre{border-radius:0.7rem;overflow:hidden;margin:1em 0;box-shadow:0 5px 60px 5px rgba(34,84,61,0.1),0 10px 15px -3px rgba(0,0,0,0.6),0 4px 6px -2px rgba(0,0,0,0.3);}> *:last-child{margin-bottom:0;}"]);
export const Head = _ref => {
  let {data: {mdx}} = _ref;
  return React.createElement(React.Fragment, null, React.createElement("title", null, mdx.frontmatter.title + " \u2013 AbleSet"), React.createElement("meta", {
    property: "og:title",
    content: mdx.frontmatter.title + " \u2013 AbleSet"
  }), React.createElement("meta", {
    name: "image",
    content: socialImage
  }), React.createElement("meta", {
    property: "og:image",
    content: socialImage
  }), React.createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), React.createElement("meta", {
    name: "twitter:image",
    content: socialImage
  }));
};
function PageTemplate(_ref2) {
  let {data: {mdx}, children} = _ref2;
  return React.createElement("div", {
    className: "flex min-h-screen flex-col"
  }, React.createElement(Header, null), React.createElement(Content, {
    className: "prose prose-invert mx-auto mb-16 flex-grow px-4 text-lg prose-pre:bg-background-light"
  }, React.createElement("h1", {
    className: "mt-4 mb-8 text-center text-3xl font-normal leading-normal md:text-5xl"
  }, mdx.frontmatter.title), React.createElement(MDXProvider, {
    components: shortcodes
  }, children)), React.createElement(Footer, null));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const pageQuery = "2257761309";
